import { Inject, Injectable } from "@angular/core";
import LiebherrAuth from "@liebherr/spa-auth";
import { User } from "oidc-client";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(@Inject("LH_AUTH") private auth: LiebherrAuth) {}

  getUser(): User {
    if (!this.auth.user) {
      throw new Error("Not authenticated");
    }
    return this.auth.user;
  }

  isLoggedIn(): boolean {
    const user = this.getUser();
    return user != null && !user.expired;
  }

  getAuthorizationHeaderValue(): string {
    const user = this.getUser();
    return `${user.token_type} ${user.access_token}`;
  }
}
